import { render, staticRenderFns } from "./JVxeFileCell.vue?vue&type=template&id=4e5d477e&scoped=true"
import script from "./JVxeFileCell.vue?vue&type=script&lang=js"
export * from "./JVxeFileCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d477e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e5d477e')) {
      api.createRecord('4e5d477e', component.options)
    } else {
      api.reload('4e5d477e', component.options)
    }
    module.hot.accept("./JVxeFileCell.vue?vue&type=template&id=4e5d477e&scoped=true", function () {
      api.rerender('4e5d477e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JVxeCells/JVxeFileCell.vue"
export default component.exports